import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import styles from './GroupedTransaction.m.sass';
import formatCurrency from '../../../../utils/formatCurrency';
import Icon from '../../../../components/Icon';
import { round, orderBy } from 'lodash';
import cx from 'classnames';
import { translate as T } from '../../../../utils/translate';
var Aux = function Aux(_ref) {
  var children = _ref.children;
  return children;
};
var GroupedTransaction = /*#__PURE__*/function (_React$Component) {
  function GroupedTransaction() {
    var _this;
    _classCallCheck(this, GroupedTransaction);
    _this = _callSuper(this, GroupedTransaction, arguments);
    _this.state = {
      collapsed: true
    };
    return _this;
  }
  _inherits(GroupedTransaction, _React$Component);
  return _createClass(GroupedTransaction, [{
    key: "toggle",
    value: function toggle() {
      this.setState({
        collapsed: !this.state.collapsed
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var transactions = orderBy(this.props.transactions, ['id'], ['desc']);
      var latestTransaction = transactions[0];
      return /*#__PURE__*/React.createElement(Aux, null, /*#__PURE__*/React.createElement("div", {
        className: styles.transactionWrapper,
        onClick: function onClick() {
          return _this2.toggle();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.transactionDate
      }, /*#__PURE__*/React.createElement(Icon, {
        material: true,
        name: this.state.collapsed ? 'arrow_right' : 'arrow_drop_down',
        title: "List View",
        className: styles.icon
      }), latestTransaction.dateCreated.format('LL')), /*#__PURE__*/React.createElement("div", {
        className: styles.transactionType
      }, "JOB DETAILS"), /*#__PURE__*/React.createElement("div", {
        className: styles.transactionInfo
      }, /*#__PURE__*/React.createElement(Aux, null, /*#__PURE__*/React.createElement("p", null, T('Web.Common.Client', 'Client'), " Name:", ' ', /*#__PURE__*/React.createElement("strong", null, latestTransaction.member.displayName)), /*#__PURE__*/React.createElement("p", null, "Job Name:", /*#__PURE__*/React.createElement("strong", null, latestTransaction.job.name || latestTransaction.job.description)), /*#__PURE__*/React.createElement("p", null, "Job Id:", ' ', /*#__PURE__*/React.createElement("strong", {
        className: styles.iconHolder,
        onClick: function onClick() {
          return window.open("/".concat(_this2.props.workspace.slug, "/jobs/").concat(latestTransaction.job.id), '_blank');
        }
      }, latestTransaction.job.id)))), /*#__PURE__*/React.createElement("div", {
        className: styles.transactionAmountTotal
      }, /*#__PURE__*/React.createElement(Aux, null, /*#__PURE__*/React.createElement("p", null, "Total Paid:", ' ', /*#__PURE__*/React.createElement("strong", null, formatCurrency(latestTransaction.job.paidAmount))), /*#__PURE__*/React.createElement("p", null, "Total:", ' ', /*#__PURE__*/React.createElement("strong", null, formatCurrency(latestTransaction.job.total)))))), !this.state.collapsed && this.renderExpanded(transactions));
    }
  }, {
    key: "renderExpanded",
    value: function renderExpanded(transactions) {
      return transactions.map(function (transaction, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: cx(styles.transactionWrapper, styles.transactionWrapperInternal),
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.transactionDate
        }, transaction.dateCreated.format('LL')), /*#__PURE__*/React.createElement("div", {
          className: styles.transactionType
        }, transaction.transactionType.includes('ADMIN_') ? 'ADJUSTMENT' : transaction.transactionType), /*#__PURE__*/React.createElement("div", {
          className: styles.transactionInfo
        }, transaction.metadata.description && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, transaction.metadata.description))), /*#__PURE__*/React.createElement("div", {
          className: styles.transactionAmount
        }, (transaction.transactionType === 'PURCHASE' || transaction.transactionType === 'ADMIN_REMOVE') && /*#__PURE__*/React.createElement("div", {
          className: styles.purchase
        }, "- ", formatCurrency(round(transaction.amount / 100, 2))), (transaction.transactionType === 'DEPOSIT' || transaction.transactionType === 'BONUS' || transaction.transactionType === 'REFUND' || transaction.transactionType === 'ADMIN_ADD') && /*#__PURE__*/React.createElement("div", {
          className: styles.deposit
        }, "+ ", formatCurrency(round(transaction.amount / 100, 2)))));
      });
    }
  }]);
}(React.Component);
export { GroupedTransaction as default };
GroupedTransaction.propTypes = {
  transactions: PropTypes.array,
  workspace: PropTypes.object
};
//# sourceMappingURL=index.js.map
